module.exports = __webpack_public_path__ + "static/media/cartoes.1f8581d3.jpg";